import anime from 'animejs';
import $ from 'jquery';

const handleActiveNav = () => {
  const currentPath = window.location.pathname;
  const filteredSlash = [...currentPath].filter(item => {
    return item === '/';
  });
  const linkPath = currentPath.substring(1);
  const linkPathParent = linkPath.substring(0, linkPath.indexOf('/'))
  let links = [];

  if (filteredSlash.length >= 2) {
    links = document.querySelectorAll(`a.nav__link[href="/${linkPathParent}"]`);
  } else {
    links = document.querySelectorAll(`a.nav__link[href="${currentPath}"]`);
  }

  links.forEach((link) => {
    link.classList.add('active');
  });
}

const handleNavSeach = (navLink, input, form, btn, e) => {
  const navSearch = document.querySelector(navLink);
  const formSearch = document.querySelector(form);
  const inputSearch = document.querySelector(input);
  const btnSearch = document.querySelector(btn);
  const onInput = navSearch.contains(e.target);

  if (!onInput && inputSearch.value.length === 0 && inputSearch !== document.activeElement) {
    anime({
      targets: input,
      maxWidth: '0px',
      duration: 400,
      easing: 'easeInOutQuad',
      begin: function () {
        setTimeout(() => {
          btnSearch.style.display = 'none';
        }, 200);
      },
      complete: function () {
        inputSearch.style.display = 'none';
        formSearch.style.display = 'none';
        navSearch.style.display = 'block';
        inputSearch.blur();
        anime({
          targets: navLink,
          opacity: 1,
          easing: 'easeInOutQuad',
          duration: 100,
        });
      },
    });
  } else {
    anime({
      targets: input,
      maxWidth: '200px',
      easing: 'easeInOutQuad',
      duration: 400,
      begin: function () {
        anime({
          targets: navLink,
          opacity: 0,
          duration: 300,
        });
        navSearch.style.display = 'none';
        formSearch.style.display = 'block';
        inputSearch.style.display = 'block';
        btnSearch.style.display = 'block';
        inputSearch.focus();
      },
    });
  }
}

handleActiveNav();

document.addEventListener('click', (e) => {
  if (window.innerWidth >= 1024) {
    handleNavSeach('.nav .nav__link.search', '.nav .input-nav-search', '.form-nav-search', '.btn-nav-search', e);
  } else {
    handleNavSeach('.nav-mobile .nav-mobile__link.search', '.nav-mobile .input-nav-search', '.form-nav-search-mobile', '.btn-nav-search-mobile', e);
  }
});



